import type { PathItemObject } from '@jotta/types/Files'
import { excludesFalse } from '@jotta/types/TypeUtils'
import { useQueries } from '@tanstack/react-query'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { usePathItem } from '../PathItem/hooks/usePathItem'
import { FileBreadCrumb } from './FileBreadCrumb'

import moize from 'moize'
import { useState } from 'react'
import { getFileRouteParams } from '../FileRoute/utils/getFileRouteParams'
import { routeParamsToApiPathBreadCrumb } from '../FileRoute/utils/routeParamsToApiPathBreadCrumb'
import { useFileStore } from '../FileStore/FileContext'
const getQueryPathItems = moize.shallow(
  (data: (PathItemObject | undefined)[]) => {
    if (data.every(excludesFalse)) {
      return data
    }
    return undefined
  },
)
export const FileBreadCrumbContainer = observer(
  function FileBreadCrumbContainer() {
    const [items, setItems] = useState<readonly PathItemObject[]>([])
    const { query, ...params } = useParams()
    const routeParams = getFileRouteParams(params)
    const store = useFileStore()
    const apiPaths = routeParamsToApiPathBreadCrumb(routeParams).slice(1)
    const { context } = routeParams
    const queries = useQueries({
      queries: apiPaths.map(path =>
        usePathItem.getFetchOptions({
          context,
          path,
        }),
      ),
    })
    const data = getQueryPathItems(queries.map(q => q.data?.pathItem))

    useEffect(() => {
      if (!data) {
        return
      }

      if (context === 'trash') {
        setItems(data.filter(item => item.deletedAtMillis))
      } else {
        setItems(data)
      }
    }, [data, context])

    return (
      <FileBreadCrumb
        onContextMenuSelect={store.folder.actions.onContextMenuSelect}
        items={items}
      />
    )
  },
)
